import React from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/auth';
import '../../styles/Header.css';

const Header = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await authService.logout();
    }
  };

  const handleAddInquiry = () => {
    navigate('/admin/inquiries'); // Changed from /admin/inquiries/add
  };

  const handleAddStudent = () => {
    navigate('/admin/students/add');
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <button className="sidebar-toggle" onClick={onToggleSidebar} title="Toggle Menu">
            <svg className="hamburger-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div className="institute-info">
            <div className="institute-logo">
              <span className="logo-icon">🎓</span>
            </div>
            <h1 className="institute-name">Ascent Computer Education</h1>
          </div>
        </div>

        <div className="header-right">
          <button className="header-btn add-inquiry-btn" onClick={handleAddInquiry}>
            <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span className="btn-text">Add Inquiry</span>
          </button>
          
          <button className="header-btn add-student-btn" onClick={handleAddStudent}>
            <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span className="btn-text">New Enrollment</span>
          </button>

          <button className="header-btn logout-btn" onClick={handleLogout}>
            <svg className="btn-icon logout-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
